import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bidi-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {

  @Output() panelState: EventEmitter<any> = new EventEmitter;
  state = false;
  constructor() { }

  ngOnInit() {
  }

  closeConfiguration() {
    this.panelState.emit({state: this.state, panel: 'Configuracion'});
  }
}
